import { buildService } from '@rd-web-markets/shared/dist/services/service';
import serviceMethods from '@rd-web-markets/shared/dist/services/service_methods';
import { useCallback } from 'react';
const costImportsApi = buildService('/claims/{id}/claim_template_unmapped_imports', {
  only: ['all']
});
const projectImportsApi = buildService('/claim_groups/{id}/project_template_unmapped_imports', {
  only: ['all']
});
const claimTemplateImportsService = {
  useFetchAll: (setLoading, claimId, claimGroupId) => {
    const [imports, setImports, fetchImports] = serviceMethods.useFetch({
      callback: useCallback(async () => {
        if (!claimId || !claimGroupId) return [];
        const [costImports, projectImports] = await Promise.all([costImportsApi.all(claimId), projectImportsApi.all(claimGroupId)]);
        const cost = (Array.isArray(costImports) ? costImports : []).filter(i => i.import_status !== 'never_imported').map(i => ({
          ...i,
          import_type: 'cost'
        }));
        const project = (Array.isArray(projectImports) ? projectImports : []).filter(i => i.import_status !== 'never_imported').map(i => ({
          ...i,
          import_type: 'project'
        }));
        return [...cost, ...project].sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
      }, [claimId, claimGroupId]),
      setLoading,
      initialStateValue: []
    });
    return [imports, setImports, fetchImports];
  },
  usePolling: function (imports, fetchImports) {
    let enabled = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    const hasPendingImports = imports.some(imp => imp.import_status === 'pending');
    serviceMethods.usePolling({
      callback: fetchImports,
      enabled: enabled && hasPendingImports,
      intervalMs: 7000
    });
  }
};
claimTemplateImportsService.useCrud = (setLoading, claimId, claimGroupId) => {
  const [imports, setImports, fetchImports] = claimTemplateImportsService.useFetchAll(setLoading, claimId, claimGroupId);
  claimTemplateImportsService.usePolling(imports, fetchImports, true);
  return {
    imports,
    setImports,
    fetchImports
  };
};
export default claimTemplateImportsService;